import PredictPlugin from './PredictPlugin'
import SerializerPlugin from './SerializerPlugin'
import ElementPlugin from './ElementPlugin'
import SingleSelectPlugin from './SingleSelectPlugin'
import MultiSelectPlugin from './MultiSelectPlugin'
import OpenPlugin from './OpenPlugin'
import NumberPlugin from './NumberPlugin'
import CommentPlugin from './CommentPlugin'
import PageBreakPlugin from './PageBreakPlugin'
import LineGroupPlugin from './LineGroupPlugin'
import HoverMenuPlugin from './HoverMenuPlugin'
import CompletionPlugin from './CompletionPlugin'
import LabelMakerPlugin from './LabelMakerPlugin'
import HelperPlugin from './HelperPlugin'
import DestructurePlugin from './DestructurePlugin'

export default [
  HelperPlugin,
  LabelMakerPlugin,
  HoverMenuPlugin,
  SerializerPlugin,
  PredictPlugin,
  ElementPlugin,
  SingleSelectPlugin,
  MultiSelectPlugin,
  OpenPlugin,
  NumberPlugin,
  CommentPlugin,
  PageBreakPlugin,
  LineGroupPlugin,
  CompletionPlugin,
  DestructurePlugin
]



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/index.js